export const MixpanelConfiguration = {
  token: '1464ddcf6cdce47d7fe1703fc58233c7',
};
